/**
 * What the Stripe Connect screen says when a request to the API fails.
 *
 * The state stored `error.message` and the screen printed it. For an Angular
 * HTTP error that is « Http failure response for https://…/onboard: 403
 * Forbidden »: the API address, in English, to a French organizer (B3 of
 * Sofia's test of 2.2.7, 27/10/2026). The screen now gets a translation key.
 *
 * The 403 is the API refusing a connected account to somebody whose pro role
 * is not active (create-connected-account.handler.ts, since 08/10/2026), and a
 * former pro still reaches this screen from a notification. Telling them so
 * is the one useful thing to say; a « try again » would be a loop.
 * The 400 is a country Stripe does not serve. Anything else keeps the
 * generic sentence.
 *
 * `status` is read structurally so this file depends on nothing from Angular.
 */
export type StripeConnectErrorKey =
  | 'STRIPE_CONNECT.ERROR_NOT_AN_ACTIVE_ORGANISER'
  | 'STRIPE_CONNECT.ERROR_COUNTRY_NOT_SERVED'
  | 'STRIPE_CONNECT.ERROR_MESSAGE';

export const theStripeErrorToShow = (error: unknown): StripeConnectErrorKey => {
  const status = (error as { status?: unknown } | null)?.status;
  if (status === 403) return 'STRIPE_CONNECT.ERROR_NOT_AN_ACTIVE_ORGANISER';
  if (status === 400) return 'STRIPE_CONNECT.ERROR_COUNTRY_NOT_SERVED';
  return 'STRIPE_CONNECT.ERROR_MESSAGE';
};
